import { create } from "zustand"

interface SessionLateCancelModalStore {
  isOpen: boolean
  sessionBookingId: number | null
  onOpen: (sessionBookingId: number) => void
  onClose: () => void
}

const useSessionLateCancelModalStore = create<SessionLateCancelModalStore>(
  (set) => ({
    isOpen: false,
    sessionBookingId: null,
    onOpen: (sessionBookingId) => set({ isOpen: true, sessionBookingId }),
    onClose: () => set({ isOpen: false, sessionBookingId: null }),
  })
)

export default useSessionLateCancelModalStore
